import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
    drawerPaper: {
      width: 260,
    },
  
    drawerHeader: {
      display: 'flex',
      flexWrap: 'nowrap',
      padding: theme.spacing.unit,
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      backgroundColor: theme.palette.grey[50],
    },
    drawerTitle: {
      flex: '1 1 auto',
      fontWeight: theme.typography.fontWeightRegular,
    },
    iconRoot: {
      fill: theme.palette.text.secondary,
      // opacity: 0.5,
      margin: 0,
    },
  
    drawerBody: {
      padding: theme.spacing.unit,
    },
  
    fwMedium: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    fwRegular: {
      fontWeight: theme.typography.fontWeightRegular,
    },
  
    detailsTitle: {
      fontWeight: theme.typography.fontWeightMedium,
      margin: `${theme.spacing.unit * 1.5}px 0 ${theme.spacing.unit / 2}px`,
    },
    label: { border: "1px solid #DFDFDF", marginLeft: 0, marginRight: 0 },
    detailsTable: {
      '& tbody': {
        '& tr': {
          height: 'auto',
          '& td': {
            padding: `${theme.spacing.unit / 2}px 0`,
            border: 0,
            '&:last-child': {
              paddingRight: 0,
            },
          },
        },
      },
    },
    marginTop10:{
      marginTop:theme.spacing.unit * 2
    },
      suggestContainer: {
          position: 'relative',
      },
      suggestList: {
          position: 'absolute',
          top: '38px',
          left: '0',
          background: '#fff',
          boxShadow: '0px 0px 2px #ccc',
          padding: 0,
          zIndex: 10,
          listStyleType: 'none',
          marginTop: 0,
      width: '100%',
      maxHeight:"150px",
      overflowY:"scroll"
      },
      suggestItem: {
          padding: theme.spacing.unit,
          paddingBottom: theme.spacing.unit + 4,
          cursor: 'pointer',
          zIndex: 11,
          '&::after': {
              content: '',
              display: 'table',
              clear: 'both',
          }
      },searchRoot: {
          padding: theme.spacing.unit / 4,
          marginTop: theme.spacing.unit,
          marginBottom: theme.spacing.unit,
          border: '1px solid #DFDFDF',
          width: '100%'
      },
  });